<div class="relative cursor-pointer">
    <!-- {{disabled}} -->
    <ng-select [disabled]="disabled || is_disabled" [items]="options" [appendTo]="appendTo" bindLabel="title" [(ngModel)]="selectedValues" [multiple]="is_multiple" [clearable]="!!selectedValues && clearable" (change)="onSelectionChange($event)" [placeholder]="label ? '' : placeholder" [compareWith]="compareFn" [closeOnSelect]="!show_checkboxes" class="block w-full text-sm text-gray-900 h-12 rounded-lg">
        <ng-template ng-option-tmp let-item="item" let-item$="item$">
            <div *ngIf="show_checkboxes" class="flex items-center gap-3 py-0.5">
                <div class="w-5 h-5 flex-shrink-0 rounded border-2 flex items-center justify-center transition-colors" [ngClass]="item$.selected ? 'border-indigo-600 bg-indigo-600' : 'border-gray-300 bg-white'">
                    <i *ngIf="item$.selected" class="bx bx-check text-white text-sm leading-none"></i>
                </div>
                <span class="capitalize">{{ item.title }}</span>
            </div>
            <div *ngIf="!show_checkboxes" class="capitalize">{{ item.title }}</div>
        </ng-template>
        <ng-template *ngIf="show_email" ng-label-tmp let-item="item">
            <div class="flex flex-col leading-tight">
                <span class="font-medium text-sm">{{ item.title }}</span>
                <span class="text-xs text-gray-500">{{ item.email }}</span>
            </div>
        </ng-template>
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="flex flex-wrap gap-1 py-1">
                <div *ngFor="let item of items" class="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-md text-sm font-medium flex items-center gap-2">
                    <span class="text-nowrap">{{ item.title }}</span>
                    <button type="button" (click)="clear(item)" class="text-primary focus:outline-none">
                        <i class="bx bx-x text-lg"></i>
                    </button>
                </div>
            </div>
        </ng-template>
    </ng-select>

    <!-- <div *ngIf="is_multiple && selectedValues?.length > 0" class="flex w-full overflow-auto no-scrollbar gap-2 mt-2">
        <div *ngFor="let item of selectedValues" class="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-md text-sm font-medium flex items-center gap-2">
            <span class="text-nowrap">{{ item.title }}</span>
            <button type="button" (click)="removeItem(item)" class="text-primary focus:outline-none">
                <i *ngIf="!disabled && !is_disabled" class="bx bx-x text-lg"></i>
            </button>
        </div>
    </div> -->

    <label *ngIf="label" [for]="label" class="absolute truncate max-w-[97%] bg-white duration-300 floating-label origin-[0] px-2 pointer-events-none text-sm top-[13px] transform transition-all z-10" [ngClass]="{
            '-translate-y-5 scale-75 text-[rgba(0,0,0,0.6)] left-1 not-italic': (is_multiple ? selectedValues?.length > 0 : (selectedValues != null && selectedValues !== '')),
            'left-[4px] text-gray-600 italic': !(is_multiple ? selectedValues?.length > 0 : (selectedValues != null && selectedValues !== ''))
        }">
        {{ label }}
        <span *ngIf="control?.hasValidator?.(required_validator)" class="col-span-2 text-red-600">*</span>
    </label>
</div>
<!-- {{value}} -->
<!-- <div *ngIf="control && control.errors && (control.dirty || control.touched)" class="error-messages ">
    <p class="text-red-500" *ngIf="control.errors.required">{{label }} is required.</p>
</div> -->
<div *ngIf="control && control.errors && (control.dirty || control.touched)" class="error-messages">
    <p class="text-red-500 text-sm" *ngIf="control.errors.required && is_multiple == false">Please select a {{ label }}.</p>
    <p class="text-red-500 text-sm" *ngIf="control.errors.required && is_multiple == true">Please select at least one {{ label }}.</p>
    <p class="text-red-500 text-sm" *ngIf="control.errors.invalidSchedulingLevel">
        Scheduling level cannot be greater than number of levels.
    </p>
</div>